import { ThresholdBar } from '../../../core/components/threshold-bar/ThresholdBar.js';
import { NumericalThresholdPosition } from '../../../core/types/thresholds.js';
import { transformThresholdsToMarkers } from '../../../core/utils/threshold-to-marker.js';
import { useSetState } from '../../hooks/store/state-setters.js';
import { useHistogramThresholds } from '../../hooks/useHistogramThresholds.js';
import { useHistogramXScale } from '../../hooks/useHistogramXScale.js';
import { useHistogramYFormatter } from '../../hooks/useHistogramYFormatter.js';
import { useHistogramYScales } from '../../hooks/useHistogramYScales.js';

interface HistogramThresholdBarProps {
  position: NumericalThresholdPosition;
  length: number;
}

export const HistogramThresholdBar = (props: HistogramThresholdBarProps) => {
  const { position, length } = props;

  const [leftScale, rightScale] = useHistogramYScales();
  const { xScale } = useHistogramXScale();
  const { leftThreshold, rightThreshold } = useHistogramThresholds();
  const [leftFormatter, rightFormatter] = useHistogramYFormatter();
  const setState = useSetState();

  const thresholds = position === 'left' ? leftThreshold : rightThreshold;
  if (!thresholds || !thresholds.length) {
    return null;
  }

  const yScale = position === 'left' ? leftScale : rightScale;
  const isFlipped = position !== 'left';
  const axisFormatter = position === 'left' ? leftFormatter : rightFormatter;

  const markers = thresholds.reduce(
    transformThresholdsToMarkers(position, xScale, yScale, axisFormatter),
    [],
  );

  const handleHover = (id: string | undefined) => {
    setState((prev) => ({
      ...prev,
      hoveredThresholdId: id,
    }));
  };

  return markers.length ? (
    <ThresholdBar
      markers={markers}
      length={length}
      layout="vertical"
      isFlipped={isFlipped}
      onHover={handleHover}
    />
  ) : null;
};

HistogramThresholdBar['displayName'] = 'HistogramThresholdBar';
